import { FC, Fragment, ReactNode, useEffect } from 'react';
import {
  Box,
  List,
  Pagination,
} from '@mui/material';

import { usePagination } from '@cvt/hooks/usePagination';
import { MessageFeedbackView } from '@cvt/components/MessageFeedbackView';

import { useSpecializations } from '../hooks/useSpecializations';

const displayAmount = 10;

interface ViewProps {
  filters?: Specializations.GetListParams;
  renderItem: (job: Specializations.Specialization) => ReactNode;
  options?: {
    enablePagination?: boolean;
  }
}

export const SpecializationsList: FC<ViewProps> = ({ filters = {}, renderItem, options }) => {

  const { totalPages, setCount, page, setPage, limit, offset } = usePagination(filters.limit || displayAmount);

  const { count, specializations, status } = useSpecializations({
    ...filters,
    offset,
    limit,
  });

  useEffect(() => {
    if (status === 'success') {
      setCount(count);
    }
  }, [status, setCount, count]);

  return (
    <Fragment>
      {status === 'error' && (
        <MessageFeedbackView height="100%"/>
      )}
      {status === 'success' && (
        <Fragment>
          {specializations.length === 0 && (
            <MessageFeedbackView height={400} message="No Specializations"/>
          )}
          {specializations.length > 0 && (
            <List disablePadding>
              {specializations.map(specialization => renderItem(specialization))}
            </List>
          )}
          {options?.enablePagination && specializations.length > 0 && (
            <Box display="flex" width="100%" p={2} mt="auto" justifyContent="center">
              <Pagination
                count={totalPages}
                page={page}
                onChange={(event, value) => setPage(value)}
                showFirstButton={page !== 1}
                showLastButton={page !== totalPages}
              />
            </Box>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};
